import { HttpService } from "../http";
import {
  CREATE_ORGANIZATION,
  DELETE_ORGANIZATION,
  FETCH_PUBLIC_COMPANY_NAMES,
  GET_ORGANIZATION_BY_DOMAIN,
  GET_ORGANIZATION_ENDPOINT,
  UPDATE_ORGANIZATION,
} from "./endpoints";

export class OrganizationService extends HttpService {
  fetchOrganizations = async (payload: any): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/${GET_ORGANIZATION_ENDPOINT}`;
    try {
      const apiResponse = await this.get(baseUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  createAdmin = async (payload: any): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/${CREATE_ORGANIZATION}`;
    try {
      const headers: Record<string, string> = {};
      if (payload instanceof FormData) {
        // When sending FormData, we should let the browser/axios set the Content-Type
        // which includes the boundary. We explicitly delete the default application/json content type.
        // However, to satisfy HttpService logic which defaults to application/json if missing,
        // we might need to pass a specific header or modify HttpService.
        // For now, let's try passing 'Content-Type': 'multipart/form-data' but relying on Axios to fix the boundary issue
        // OR pass undefined to override the default.
        // A common trick with custom HttpService wrappers is to pass a flag or specific header.
        // Let's assume HttpService allows overriding headers.
        // If we pass 'Content-Type': undefined, it might not work if types are strict.
        // Let's try passing a specific header that we know overrides the check or use 'multipart/form-data'
        // But 'multipart/form-data' without boundary is bad.
        // Looking at HttpService: if (!headers["Content-Type"]) headers["Content-Type"] = "application/json";
        // So we MUST provide a Content-Type.
        // If we provide "multipart/form-data", axios might not add the boundary automatically?
        // Actually, modern axios might handle it if data is FormData.
        // Let's rely on passing no header here and letting HttpService default to JSON? NO.
        // We need to bypass the default JSON header.
        // Method 1: Pass { "Content-Type": "multipart/form-data" }
        // Method 2: Pass { "Content-Type": undefined } as any
      }

      const options =
        payload instanceof FormData
          ? {
              headers: { "Content-Type": "multipart/form-data" },
            }
          : {};

      // Note: If this fails due to missing boundary, we will need to adjust HttpService
      // or use a specific value that HttpService respects but Axios overwrites.

      const apiResponse = await this.post(baseUrl, payload, options);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  updateAdmin = async (payload: any): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const adminId =
      payload instanceof FormData ? payload.get("id") : payload.id;
    const baseUrl = `${baseAuthUrl}/${UPDATE_ORGANIZATION}/${adminId}`;
    try {
      const options =
        payload instanceof FormData
          ? {
              headers: { "Content-Type": "multipart/form-data" },
            }
          : {};

      const apiResponse = await this.patch(baseUrl, payload, options);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  deleteAdmin = async (payload: any): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/${DELETE_ORGANIZATION}/${payload.id}`;
    try {
      const apiResponse = await this.delete(baseUrl);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  fetchPublicCompanyNames = async (payload?: any): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/${FETCH_PUBLIC_COMPANY_NAMES}`;
    try {
      const apiResponse = await this.get(baseUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  getOrganizationByDomain = async (domain: string): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/${GET_ORGANIZATION_BY_DOMAIN}`;
    try {
      const apiResponse = await this.get(baseUrl, { domain });
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };
}
